export const ROUTE_ASSIGNED_TO_OTHER = "Route already assigned to someone else";
export const ROUTE_ALREADY_COMPLETED = "Route has already been completed";
export const EXCEPTION = "Unexpected error occurred";
export const UNABLE_TO_ASSIGN_ROUTE = "Couldn't able to assign route";
export const UNABLE_TO_FETCH_ROUTE_INFO = "Couldn't able fetch the route info";
export const UNABLE_TO_FETCH_ROUTE_ASSIGNMENT = "Couldn't able fetch the route assignment info";
